import CustomIcon from "components/WasteTypeCustomIcon/WasteTypeCustomIcon";
import IWorkOrderStatusViewModel from "interfaces/IWorkOrderStatusViewModel";
import { useCallback, useState } from "react";

const ContainerTemplate = (props: IWorkOrderStatusViewModel): any => {
  const workOrderStatus = props;
  const [, setIconLoaded] = useState<boolean>(false);

  const handleOnCompleted = useCallback(
    _ => setIconLoaded(true),
    [setIconLoaded]
  );

  const handleIconError = useCallback(
    _ => setIconLoaded(false),
    [setIconLoaded]
  );

  const renderColumnValue = (): any => (
    <>
      <CustomIcon
        id={props.containerId!}
        wasteTypeId={props.containerWasteTypeId!}
        onCompleted={handleOnCompleted}
        onError={handleIconError}
      />
      <span className="ms-1 fw-bold">{workOrderStatus.containerWasteType}</span>
      <br />
      <span className="size-header">
        {props.containerSize}
        &nbsp;
        {`${props.containerName}`}
      </span>
    </>
  );

  return renderColumnValue();
};
export default ContainerTemplate;
